import React from 'react'

const list = props => {

  const total = props.items.reduce((total, data) => total + parseInt(data.amount), 0);

  return (
    <table>
      <tbody>
        <tr key="01">
          <th>Particular</th>
          <th>Amount</th>
          <th>Action</th>
        </tr>
        {
          props.items.map(todo =>(
            <tr key={todo.id} >
              <td style={{textAlign: 'left'}}>{todo.name}</td>
              <td style={{textAlign: 'right'}}>{todo.amount}</td>
              <td onClick={() => props.onClick(todo.id)}><button>X</button></td>
            </tr>
          ))
        }
        <tr key="02">
          <th>TOTAL</th>
          <th style={{textAlign: 'right'}}>{total}</th>
          <th></th>
        </tr>
      </tbody>
    </table>
  )
}

export default list;



// WEBPACK FOOTER //
// ./src/components/CashInHand/list.js